import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { OctagonButton } from "@/common/buttons";
import { InlineDiv } from "@/common/divs";
import { InputWithNoBorder } from "@/common/inputs";

import {
  PRIMARY_BRAND_VARIANT_COLOR,
  PRIMARY_BUTTON_COLOR,
  PRIMARY_BUTTON_COLOR_DISSABLED,
  SECONDARY_BUTTON_COLOR,
} from "@/utils/constants";

interface SeatsInputProps {
  min: number;
  max: number;
  globalCapacity: number | undefined;
  personas: string[];
  setPersonas: (personas: string[]) => void;
  index: number;
  setDisableBookButton: (value: boolean) => void;
}
const SeatsInputGlobal: React.FC<SeatsInputProps> = ({
  min,
  max,
  personas,
  globalCapacity,
  setPersonas,
  index,
  setDisableBookButton,
}) => {
  const handleChangePersonas = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === "") {
      const auxPersonas = personas;
      auxPersonas[index] = event.target.value;
      //@ts-ignore
      setPersonas((prevState) =>
        prevState.map((item: string, i: number) =>
          i === index ? personas[index] : item,
        ),
      );

      if (auxPersonas.every((p) => p === "0" || p === "")) {
        setDisableBookButton(true);
      } else {
        if (getSumOfPersonas() < min) {
          setDisableBookButton(true);
        } else {
          setDisableBookButton(false);
        }
      }
    }
    if (parseInt(event.target.value) <= max) {
      if (globalCapacity) {
        const auxPersonas = personas;
        auxPersonas[index] = event.target.value;
        let sum = 0;
        for (let i = 0; i < auxPersonas.length; i++) {
          if (auxPersonas[i] != "") {
            sum = parseInt(auxPersonas[i]) + sum;
          }
        }
        if (sum <= globalCapacity) {
          const auxPersonas = personas;
          auxPersonas[index] = event.target.value;
          //@ts-ignore
          setPersonas((prevState) =>
            prevState.map((item: string, i: number) =>
              i === index ? personas[index] : item,
            ),
          );
        } else {
          return;
        }
      } else {
        const auxPersonas = personas;
        auxPersonas[index] = event.target.value;
        //@ts-ignore
        setPersonas((prevState) =>
          prevState.map((item: string, i: number) =>
            i === index ? personas[index] : item,
          ),
        );
      }

      //if all of the personas elements are 0 or "", the book button is disabled
      if (personas.every((p) => p === "0" || p === "")) {
        setDisableBookButton(true);
      } else {
        if (getSumOfPersonas() < min) {
          setDisableBookButton(true);
        } else {
          setDisableBookButton(false);
        }
      }
    }
  };

  const getSumOfPersonas = () => {
    let sum = 0;
    for (let i = 0; i < personas.length; i++) {
      if (personas[i] != "") {
        sum = parseInt(personas[i]) + sum;
      }
    }

    return sum;
  };

  const handleIncrement = () => {
    if (personas[index] == "") {
      const auxPersonas = personas;
      auxPersonas[index] = "1";
      setPersonas(auxPersonas);
    }
    if (parseInt(personas[index]) < max) {
      if (globalCapacity) {
        const auxPersonas = personas;
        auxPersonas[index] = (parseInt(personas[index]) + 1).toString();
        let sum = 0;
        for (let i = 0; i < auxPersonas.length; i++) {
          if (auxPersonas[i] != "") {
            sum = parseInt(auxPersonas[i]) + sum;
          }
        }
        if (sum <= globalCapacity) {
          //@ts-ignore
          setPersonas((prevState) =>
            prevState.map((item: string, i: number) =>
              i === index ? personas[index] : item,
            ),
          );
        } else {
          auxPersonas[index] = (parseInt(personas[index]) - 1).toString();
          return;
        }
      } else {
        const auxPersonas = personas;
        auxPersonas[index] = (parseInt(personas[index]) + 1).toString();
        //@ts-ignore
        setPersonas((prevState) =>
          prevState.map((item: string, i: number) =>
            i === index ? personas[index] : item,
          ),
        );
      }

      //if all of the personas elements are 0 or "", the book button is disabled
      if (personas.every((p) => p === "0" || p === "")) {
        setDisableBookButton(true);
      } else {
        if (getSumOfPersonas() < min) {
          setDisableBookButton(true);
        } else {
          setDisableBookButton(false);
        }
      }
    }
  };

  const handleDecrement = () => {
    if (parseInt(personas[index]) > 0) {
      const auxPersonas = personas;
      auxPersonas[index] = (parseInt(personas[index]) - 1).toString();
      //@ts-ignore
      setPersonas((prevState) =>
        prevState.map((item: string, i: number) =>
          i === index ? personas[index] : item,
        ),
      );

      //if all of the personas elements are 0 or "", the book button is disabled
      if (personas.every((p) => p === "0" || p === "")) {
        setDisableBookButton(true);
      } else {
        if (getSumOfPersonas() < min) {
          setDisableBookButton(true);
        } else {
          setDisableBookButton(false);
        }
      }
    }
  };
  const getBorderColor = (simbol: string) => {
    if (simbol === "+") {
      if (globalCapacity) {
        if (getSumOfPersonas() == globalCapacity) {
          return PRIMARY_BUTTON_COLOR_DISSABLED;
        }
      }
      if (personas[index] === max.toString()) {
        return PRIMARY_BUTTON_COLOR_DISSABLED;
      } else {
        return PRIMARY_BUTTON_COLOR;
      }
    } else {
      if (personas[index] === "0" || personas[index] === "") {
        return PRIMARY_BUTTON_COLOR_DISSABLED;
      } else {
        return PRIMARY_BUTTON_COLOR;
      }
    }
  };

  const getBackgroundColor = (simbol: string) => {
    if (simbol === "+") {
      if (globalCapacity) {
        if (getSumOfPersonas() == globalCapacity) {
          return SECONDARY_BUTTON_COLOR;
        }
      }
      if (personas[index] === max.toString()) {
        return SECONDARY_BUTTON_COLOR;
      } else {
        return PRIMARY_BRAND_VARIANT_COLOR;
      }
    } else {
      if (personas[index] === "0" || personas[index] === "") {
        return SECONDARY_BUTTON_COLOR;
      } else {
        return PRIMARY_BRAND_VARIANT_COLOR;
      }
    }
  };
  return (
    <InlineDiv style={{ alignItems: "center" }}>
      <OctagonButton
        style={{
          borderRadius: "50px",
          border: "1px solid " + getBorderColor("-"),
        }}
        width="24px"
        height="24px"
        backgroundColor={getBackgroundColor("-")}
        onClick={() => {
          handleDecrement();
        }}
      >
        <RemoveIcon fontSize="small" style={{ color: getBorderColor("-") }} />
      </OctagonButton>
      <InputWithNoBorder
        type="number"
        className="personas-input"
        placeholder="1"
        name="personas"
        value={personas[index]}
        onChange={(e) => {
          handleChangePersonas(e);
        }}
      />
      <OctagonButton
        style={{
          borderRadius: "50px",
          border: "1px solid " + getBorderColor("+"),
        }}
        width="24px"
        height="24px"
        backgroundColor={getBackgroundColor("+")}
        onClick={() => {
          handleIncrement();
        }}
      >
        <AddIcon fontSize="small" style={{ color: getBorderColor("+") }} />
      </OctagonButton>
    </InlineDiv>
  );
};

export default SeatsInputGlobal;
